import React from "react";
import { useLocation } from 'react-router-dom';
import { Disclosure } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import logo from '../assets/logo_dang.png';

let navigation = [
  { name: 'VOD', href: '/', current: true },
  { name: 'CLIP', href: '/clip', current: false },
  { name: 'Twitch', href: 'https://www.twitch.tv/liok0485', current: false },
  { name: 'Youtube', href: 'https://www.youtube.com/@SOONDANGMOO', current: false },
  { name: 'Instagram', href: 'https://www.instagram.com/qingcha94', current: false },
  { name: 'Ncafe', href: 'https://cafe.naver.com/liok0485', current: false },
  { name: 'Tgd', href: 'https://tgd.kr/s/liok0485', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navigation() {
  console.log(useLocation().pathname);
  if (useLocation().pathname === "/clip") {
    navigation[0].current = false;
    navigation[1].current = true;
  } else {
    navigation[0].current = true;
    navigation[1].current = false;
  }

  return (
    <>
      <Disclosure as="nav" className="drop-shadow-sm bg-[#EDEEF7] z-40" style={{ position: 'fixed', top: 0, left: 0, right: 0 }}>
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
              <div className="relative flex h-16 items-center justify-between">
                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                  {/* Mobile menu button*/}
                  <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-[#111827]">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-between">
                  <div className="flex flex-shrink-0 items-center">
                    <a href="/">
                      <img
                        className="block h-8 w-auto lg:hidden"
                        src={logo}
                        alt="순로고"
                      />
                    </a>
                    <a href="/">
                      <img
                        className="hidden h-8 w-auto lg:block"
                        src={logo}
                        alt="순로고"
                      />
                    </a>
                  </div>
                  <div className="hidden sm:ml-6 sm:block ">
                    <div className="flex space-x-4">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className={classNames(
                          item.current ? 'bg-[#59825D] text-white' : 'text-[#434448] hover:bg-[#718F74] hover:text-white',
                            'rounded-md px-3 py-2 text-sm font-medium'
                          )}
                          aria-current={item.current ? 'page' : undefined}
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden">
              <div className="space-y-1 px-2 pb-3 pt-2">
                {navigation.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as="a"
                    href={item.href}
                    className={classNames(
                      item.current ? 'bg-[#59825D] text-white' : 'text-[#434448] hover:bg-[#718F74] hover:text-white',
                      'block rounded-md px-3 py-2 text-base font-medium'
                    )}
                    aria-current={item.current ? 'page' : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>
            </Disclosure.Panel>
            
            <div className="w-full h-[1px] bg-gray-300"></div>
          </>
        )}
      </Disclosure>
    </>

  )
}